import { createFileRoute, redirect } from '@tanstack/react-router'
import { AlertDetails } from 'pages/alerts/AlertDetails'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { alertsSearchSchema } from 'routes/alerts/-searchParams'

const RouteComponent = () => {
  const search = Route.useSearch()
  if (!search.selectedAlertId) return null

  return (
    <AlertDetails
      siteId={search[SEARCH_PARAM_SITE_ID]}
      alertId={search.selectedAlertId}
    />
  )
}

export const Route = createFileRoute('/alerts/details')({
  component: RouteComponent,
  validateSearch: alertsSearchSchema,
  beforeLoad: ({ search }) => {
    if (!search.selectedAlertId) {
      throw redirect({
        to: '/alerts',
        search,
      })
    }
  },
  staticData: {
    title: 'Alert Details',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: false,
    },
  },
})
